import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import "./Create.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import JoditEditor from "jodit-react";
import { variant_type } from "../../../../utils/common";
import SingleVarient from "../DoubleVarient";
import DoubleVarient from "../DoubleVarient";
function Create() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    trigger,
    setValue,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      variants: [{ name: "", price: "", mrp: "", image: "", description: "" }], // Default empty field
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    setValue("variant_name", "Colours");
  }, [setValue]);

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register("variants", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setVariantsError(isValid ? "" : "At least one variant is required");
        return isValid;
      },
    });
  }, [register]);
  const variantType = watch("variant_type_id");

  useEffect(() => {
    fields.forEach((_, index) => {
      register(`variants.${index}.images`, {
        validate: (value) =>
          (value && value.length > 0) || "At least one image is required",
      });
    });
  }, [fields, register]);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("price", data?.price);
      DataToSend.append("mrp", data?.mrp);
      // DataToSend.append("general_stock", data?.general_stock);
      // DataToSend.append("subscription_stock", data?.subscription_stock);
      DataToSend.append("manufacturer", data?.manufacturer);
      DataToSend.append("description", data?.description);
      DataToSend.append("composition", data?.composition);
      DataToSend.append("advantages", data?.advantages);
      DataToSend.append("preservation", data?.preservation);
      DataToSend.append("tax_percentage", data?.tax_percentage);
      DataToSend.append("p_category_id", data?.p_category_id?.value);
      // DataToSend.append("shape_id", data?.shape_id?.value);
      DataToSend.append("p_sub_category_id", data?.p_sub_category_id?.value);
      // DataToSend.append("expiry_date", data?.expiry_date);
      // DataToSend.append("p_child_category_id",data?.p_child_category_id?.value,);
      DataToSend.append("variant_name", data?.variant_name);
      // DataToSend.append("unit_id", data?.unit_id?.value);
      DataToSend.append("variant_type_id", data?.variant_type_id?.value);

      if (data?.brand_id?.value) {
        DataToSend.append("brand_id", data?.brand_id?.value);
      }
      DataToSend.append("image", data.image[0]);
      // DataToSend.append("video", data.video[0]);
      DataToSend.append("lic_no", data?.lic_no);
      DataToSend.append("tag", data?.tag);
      // if (data?.is_cod) {
      //   DataToSend.append("is_cod", data?.is_cod);
      // }
      if (data?.preservation_status) {
        DataToSend.append(
          "preservation_status",
          data?.preservation_status ? 1 : 0,
        );
      }
      if (data?.advantages_status) {
        DataToSend.append("advantages_status", data?.advantages_status ? 1 : 0);
      }
      if (data?.composition_status) {
        DataToSend.append(
          "composition_status",
          data?.composition_status ? 1 : 0,
        );
      }
      if (data?.description_status) {
        DataToSend.append(
          "description_status",
          data?.description_status ? 1 : 0,
        );
      }
      if (data?.is_returnable) {
        DataToSend.append("is_returnable", data?.is_returnable ? 1 : 0);
      }
      DataToSend.append("made_in_id", data?.made_in_id?.value);

      // Append the images (multiple files)
      if (data?.images && data?.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
          DataToSend.append("images", data.images[i]);
        }
      }
      // DataToSend.append(
      //   "delivery_type_id",
      //   JSON.stringify(data.delivery_type_id.map((option) => option.value))
      // );

      const variants = [];

      data.variants?.forEach((variant, index) => {
        variant.images?.forEach((file) => {
          DataToSend.append(`variants[${index}][images]`, file);
        });
        const singleVariant = {
          price: variant?.price ?? null,
          mrp: variant?.mrp ?? null,
          metal_id: variant?.metal_id?.value ?? null,
          description: variant?.description ?? null,
          double_variants: [],
        };

        if (Array.isArray(variant?.double_variants)) {
          variant.double_variants.forEach((doubleVal) => {
            const doubleVariant = {
              mrp: doubleVal?.mrp ?? null,
              price: doubleVal?.price ?? null,
              size_id: doubleVal?.size_id?.value ?? null,
              triple_variants: [],
            };

            if (Array.isArray(doubleVal?.triple_variants)) {
              doubleVal.triple_variants.forEach((tripleVal) => {
                doubleVariant.triple_variants.push({
                  mrp: tripleVal?.mrp ?? null,
                  price: tripleVal?.price ?? null,
                  diamond_id: tripleVal?.diamond_id?.value ?? null,
                });
              });
            }

            singleVariant.double_variants.push(doubleVariant);
          });
        }

        variants.push(singleVariant);
      });

      DataToSend.append("variants", JSON.stringify(variants));

      const response = await postData("/admin/products", DataToSend);
      console.log(response, " responseresponse response response from add ");
      if (response?.success) {
        await setShowModal({ code: response.code, message: response?.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        reset();
        setShowModal(0);
        navigate("/products");
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [Countries, setCountries] = useState([]);
  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [VarientType, setVarientType] = useState([]);
  const [DeliveryType, setDeliveryType] = useState([]);
  const [shapes, setShape] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [videoPreview, setVideoPreview] = useState(null);
  const [Metals, setMetal] = useState([]);
  const [Sizes, setSize] = useState([]);
  const [Diamonds, setDiamond] = useState([]);
  const [VariantNameOptions, setVariantNameOptions] = useState([]);
  const [mediaPreviews, setMediaPreviews] = useState([]);

  const getAllBrands = async () => {
    const response = await getData(`/common/masters/all-brands`);
    if (response?.success) {
      setBrands(await Select2Data(response?.data, "brand_id"));
    }
  };

  const getAllShapes = async () => {
    const response = await getData(`/common/masters/all-shape`);
    if (response?.success) {
      setShape(await Select2Data(response?.data, "shape_id"));
    }
  };
  const getAllUnits = async () => {
    const response = await getData(`/common/masters/all-units`);
    if (response?.success) {
      setUnits(await Select2Data(response?.data, "unit_id"));
    }
  };
  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-p-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-vendor-p-sub-categories/${id}`,
    );
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "p_sub_category_id"));
    }
  };

  const getAllChildCategories = async (id) => {
    const response = await getData(
      `/common/masters/all-p-child-category/${id}`,
    );
    if (response?.success) {
      setChildCategories(
        await Select2Data(response?.data, "p_child_category_id"),
      );
    }
  };
  const getAllCountries = async () => {
    const response = await getData(`/common/masters/all-country`);
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "made_in_id"));
    }
  };
  const getAllVarientType = async () => {
    const response = await getData(`/common/masters/all-variant-type`);
    if (response?.success) {
      setVarientType(await Select2Data(response?.data, "variant_type_id"));
    }
  };

  const getAllDeliveryType = async () => {
    const response = await getData(`/common/masters//all-delivery-type`);
    if (response?.success) {
      setDeliveryType(await Select2Data(response?.data, "farmer_id"));
    }
  };

  const getAllMetal = async () => {
    const response = await getData(`/common/masters/all-metal`);
    if (response?.success) {
      setMetal(await Select2Data(response?.data, "metal_id"));
    }
  };

  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  const getAllDiamond = async () => {
    const response = await getData(`/common/masters/all-diamond`);
    if (response?.success) {
      setDiamond(await Select2Data(response?.data, "diamond_id"));
    }
  };

  const variants = watch("variants");

  const handleVariantImagesChange = (e, index) => {
    const files = Array.from(e.target.files);
    const existingImages = getValues(`variants.${index}.images`) || [];
    const updatedImages = [...files, ...existingImages];
    setValue(`variants.${index}.images`, updatedImages);
    trigger(`variants.${index}.images`);
  };

  // const handleRemoveVariantImage = (variantIndex, imageIndex) => {
  //   const images = getValues(`variants.${variantIndex}.images`) || [];

  //   images.splice(imageIndex, 1);

  //   setValue(`variants.${variantIndex}.images`, [...images]);
  // };

  const getAllVariantNames = async () => {
    const response = await getData(`/common/masters/all-colours`);
    console.log(response, " response response++ ");
    if (response?.success) {
      setVariantNameOptions(await Select2Data(response?.data, "variant_name"));
    }
  };

  useEffect(() => {
    getAllSize();
    getAllDiamond();
    getAllMetal();
    getAllVariantNames();
    getAllCountries();
    getAllBrands();
    getAllUnits();
    getAllCategories();
    getAllVarientType();
    getAllDeliveryType();
    getAllShapes();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImagesChange = (e) => {
    const files = e.target.files;
    if (files) {
      const previews = [];
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push(reader.result);
          if (previews.length === files.length) {
            setImagePreviews(previews);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setVideoPreview(previewUrl);
    }
  };

  const handleRemoveVariantImage = async (variantIndex, imageIndex) => {
    const images = getValues(`variants.${variantIndex}.images`) || [];
    const target = images[imageIndex];

    // if (!window.confirm("Delete this image?")) return;

    // If API image
    if (target?.id) {
      try {
        await deleteData(`/admin/products/image-delete/${target.id}`);
      } catch (err) {
        // alert("Failed to delete image");
        return;
      }
    }

    images.splice(imageIndex, 1);
    setValue(`variants.${variantIndex}.images`, [...images]);
    trigger(`variants.${variantIndex}.images`);
  };

  const handleMediaChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);

      // Get current images from form state
      const currentImages = getValues("images") || [];

      // Combine existing and new files
      const allFiles = [...currentImages, ...fileArray];

      // Update form value
      setValue("images", allFiles);

      // Clear any validation errors
      clearErrors("images");

      // Trigger validation
      trigger("images");

      // Create previews
      const previews = [];
      fileArray.forEach((file) => {
        const reader = new FileReader();
        const isVideo = file.type.startsWith("video/");

        reader.onloadend = () => {
          previews.push({
            url: reader.result,
            type: isVideo ? "video" : "image",
            file: file,
          });

          if (previews.length === fileArray.length) {
            setMediaPreviews((prev) => [...prev, ...previews]);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const removeMedia = (indexToRemove) => {
    const currentImages = getValues("images") || [];
    const updatedImages = currentImages.filter(
      (_, index) => index !== indexToRemove,
    );
    setValue("images", updatedImages);
    setMediaPreviews((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
    trigger("images");
    if (updatedImages.length === 0) {
      clearErrors("images");
    }
  };

  return (
    <>
      <Header title={"Create Product"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        <div className="back_btn_holder d-flex ">
          <div onClick={() => navigate(`/products`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* 1. Order Details start */}
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>1. Product Category</h6>
            </div>
            <div className="package-details-section">
              <div className="pending-table ">
                <div className="row ">
                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={categories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllSubCategories(selectedValue?.value);
                            setValue("p_sub_category_id", "");
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_category_id && (
                      <span className="text-danger">
                        {errors.p_category_id.message}
                      </span>
                    )}
                  </div>

                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Sub Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_sub_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Sub Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_sub_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={subCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_sub_category_id && (
                      <span className="text-danger">
                        {errors.p_sub_category_id.message}
                      </span>
                    )}
                  </div>

                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Child Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_child_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Child Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_child_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={childCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_child_category_id && (
                      <span className="text-danger">
                        {errors.p_child_category_id.message}
                      </span>
                    )}
                  </div> */}

                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Brand</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`brand_id`} // name of the field
                      control={control}
                      rules={
                        {
                          // required: "Select Sub Category",
                        }
                      }
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.brand_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={brands}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.brand_id && (
                      <span className="text-danger">
                        {errors.brand_id.message}
                      </span>
                    )}
                  </div>
                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Style</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`shape_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Shape",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.shape_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={shapes}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.shape_id && (
                      <span className="text-danger">
                        {errors.shape_id.message}
                      </span>
                    )}
                  </div> */}

                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Made In</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`made_in_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Product",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.made_in_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={Countries}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.made_in_id && (
                      <span className="text-danger">
                        {errors.made_in_id.message}
                      </span>
                    )}
                  </div>

                  {/* 
                  <Row className="detail-row">
                    <Col md={12}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>
                            Is Returnable{" "}
                            <Form.Check
                              type="switch"
                              id="is_returnable" // Give it an id for accessibility
                              label=""
                              name="is_returnable"
                              checked={watch("is_returnable")} // Assuming you're using react-hook-form to track state
                              onChange={(e) => {
                                setValue("is_returnable", e.target.checked);
                              }} // Update form state on toggle
                              className={classNames("", {
                                "is-invalid": errors?.is_returnable,
                              })}
                            />
                          </Form.Label>

                        </Row>
                      </div>
                    </Col>
                  </Row> */}

                  {/* 
                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Expiry Date Alert Days</Form.Label>
                    <Form.Control
                      type="text"
                      name="expity_date_days"
                      placeholder="Expiry Date Alert Days"
                      className={classNames("", {
                        "is-invalid": errors?.expity_date_days,
                      })}
                      {...register("expity_date_days", {
                        required: "Expiry Date Alert Days is required",
                      })}
                      onKeyDown={(e) => {
                        // Allow: Backspace, Tab, Arrow keys, Delete
                        if (
                          [
                            "Backspace",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                            "Delete",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Prevent non-numeric keys
                        if (!/^[0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />

                    {errors.expity_date_days && (
                      <span className="text-danger">
                        {errors.expity_date_days.message}
                      </span>
                    )}
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>2. Product</h6>
            </div>
            <div className="package-details-section">
              {/* Package Weight */}
              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Name</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="text"
                      name={`name`}
                      placeholder="name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register(`name`, {
                        required: "name is required",
                        validate: (value) => {
                          const words = value.match(/\b\w+\b/g);
                          return (
                            !words ||
                            words.length <= 50 ||
                            "Data must be 100 words or less"
                          );
                        },
                      })}
                    />
                  </div>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Thumbnail Upload image (928 × 945 px).
                  </div>
                </Col>

                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="file"
                      name="image"
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      {...register("image", {
                        required: "Image is required",
                      })}
                      accept="image/*, video/*"
                      onChange={handleImageChange}
                    />
                  </div>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </Col>

                <Col lg={4} md={4}>
                  {imagePreview && (
                    <div className="Preview_img_holder">
                      {/* Check if the preview is an image or video */}
                      {imagePreview.includes("video") ? (
                        // Display video preview if it's a video
                        <video
                          className="Preview_video"
                          autoPlay
                          muted
                          loop
                          // controls
                          style={{ maxWidth: "300px" }}
                        >
                          <source src={imagePreview} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        // Display image preview if it's an image
                        <img
                          className="Preview_img"
                          src={imagePreview}
                          alt="Category Preview"
                          style={{ height: "100px", width: "auto" }}
                        />
                      )}
                    </div>
                  )}
                </Col>
              </Row>
              {/* 
              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">
                    Video Upload (MP4 / WebM / OGG – Max 10MB)
                  </div>
                </Col>

                <Col lg={4} md={4}>
                  <Form.Control
                    type="file"
                    name="video"
                    className={classNames("", {
                      "is-invalid": errors?.video,
                    })}
                    accept="video/mp4,video/webm,video/ogg"
                    {...register("video", {
                      required: "Video is required",
                      validate: (value) => {
                        if (!value || !value.length) return true;

                        const file = value[0];
                        const allowedTypes = [
                          "video/mp4",
                          "video/webm",
                          "video/ogg",
                        ];

                        
                        if (!allowedTypes.includes(file.type)) {
                          return "Only MP4, WebM, or OGG video formats are allowed";
                        }

                        

                        return true;
                      },
                    })}
                    onChange={handleVideoChange}
                  />

                  {errors.video && (
                    <span className="text-danger">{errors.video.message}</span>
                  )}
                </Col>

                <Col lg={4} md={4}>
                  {videoPreview && (
                    <div className="Preview_img_holder">
                      <video
                        className="Preview_video"
                        controls
                        muted
                        style={{ maxWidth: "300px" }}
                      >
                        <source src={videoPreview} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </Col>
              </Row> */}

              {/* <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Unit</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className=" ">
                    <Controller
                      className="select-contoller "
                      name={`unit_id`} 
                      control={control}
                      rules={{
                        required: "Select Unit",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.unit_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          options={units}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                  </div>
                  {errors.unit_id && (
                    <span className="text-danger">
                      {errors.unit_id.message}
                    </span>
                  )}
                </Col>
              </Row> */}
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3. Details</h6>
            </div>

            <div className="package-details-section">
              <Row className="detail-row">
                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tax Percentage</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tax_percentage`}
                          placeholder="Tax Percentage (%)"
                          className={classNames("", {
                            "is-invalid": errors?.tax_percentage, // Adjusted error checking
                          })}
                          {...register(`tax_percentage`, {
                            required: "Tax Percentage is required",
                            validate: (value) => {
                              const numericValue = parseFloat(value);
                              if (numericValue > 100) {
                                return "Tax percentage cannot exceed 100";
                              }
                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                            if (
                              !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight" &&
                              e.key !== "."
                            ) {
                              e.preventDefault(); // Prevent the event if it's not allowed
                            }

                            // Prevent entering more than one decimal point
                            if (e.key === "." && e.target.value.includes(".")) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            // Ensure the value stays within the range of 0 to 100
                            const value = e.target.value;
                            if (parseFloat(value) > 100) {
                              e.target.value = "100"; // Set the value to 100 if it exceeds
                            }
                          }}
                        />
                        {errors.tax_percentage && (
                          <span className="text-danger">
                            {errors.tax_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Manufacturer</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`manufacturer`}
                          placeholder="manufacturer"
                          className={classNames("", {
                            "is-invalid": errors?.manufacturer, // Adjusted error checking
                          })}
                          {...register(`manufacturer`, {
                            required: "manufacturer is required",
                          })}
                        />
                        {errors.manufacturer && (
                          <span className="text-danger">
                            {errors.manufacturer.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>License No</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`lic_no`}
                          placeholder="License No"
                          className={classNames("", {
                            "is-invalid": errors?.lic_no, // Adjusted error checking
                          })}
                          {...register(`lic_no`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.lic_no && (
                          <span className="text-danger">
                            {errors.lic_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Tag</Form.Label>
                      <Form.Group>
                        <Form.Control
                          type="text"
                          name={`tag`}
                          placeholder="Tag"
                          className={classNames("", {
                            "is-invalid": errors?.tag, // Adjusted error checking
                          })}
                          {...register(`tag`, {
                            // required: "License No is required",
                          })}
                        />
                        {errors.tag && (
                          <span className="text-danger">
                            {errors.tag.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Description{" "}
                        <Form.Check
                          type="switch"
                          id="description_status" // Give it an id for accessibility
                          label=""
                          name="description_status"
                          checked={watch("description_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("description_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.description_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="description"
                          control={control}
                          rules={{
                            required: "description is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("description");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Specifications
                        <Form.Check
                          type="switch"
                          id="advantages_status" // Give it an id for accessibility
                          label=""
                          name="advantages_status"
                          checked={watch("advantages_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("advantages_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.advantages_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        {/* <Form.Control
                          type="text"
                          as={"textArea"}
                          name={`advantages`}
                          placeholder="Advantages"
                          className={classNames("", {
                            "is-invalid": errors?.advantages, // Adjusted error checking
                          })}
                          {...register(`advantages`, {
                            required: "Advantages is required",
                          })}
                        /> */}
                        <Controller
                          name="advantages"
                          control={control}
                          rules={{
                            required: "advantages is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("advantages");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.advantages && (
                          <span className="text-danger">
                            {errors.advantages.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>
                        Size Chart{" "}
                        <Form.Check
                          type="switch"
                          id="composition_status" // Give it an id for accessibility
                          label=""
                          name="composition_status"
                          checked={watch("composition_status")} // Assuming you're using react-hook-form to track state
                          onChange={(e) => {
                            setValue("composition_status", e.target.checked);
                          }} // Update form state on toggle
                          className={classNames("", {
                            "is-invalid": errors?.composition_status,
                          })}
                        />
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="composition"
                          control={control}
                          rules={{
                            required: "composition is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("composition");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.composition && (
                          <span className="text-danger">
                            {errors.composition.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
            <Form.Label>Variant Type</Form.Label>
            <Controller
              className="select-contoller"
              name={`variant_type_id`} // name of the field
              control={control}
              rules={{
                required: "Select Variant Type",
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderColor: errors?.variant_type_id
                        ? "red"
                        : baseStyles.borderColor,
                    }),
                  }}
                  options={VarientType}
                  onChange={(selectedValue) => {
                    onChange(selectedValue);
                  }}
                  onBlur={onBlur}
                  value={value}
                  ref={ref}
                />
              )}
            />
            {errors.variant_type_id && (
              <span className="text-danger">
                {errors.variant_type_id.message}
              </span>
            )}
          </div>

          <Col md={3}>
            <div className="main-form-section mt-3">
              <Row className="justify-content-center">
                <Form.Label>Variant Name</Form.Label>
                <Form.Group>
                  {/* <Form.Control
                    type="text"
                    name={`variant_name`}
                    placeholder="Variant Name"
                    className={classNames("", {
                      "is-invalid": errors?.variant_name, // Adjusted error checking
                    })}
                    {...register(`variant_name`, {
                      required: "Variant Name is required",
                    })}
                  /> */}
                  <Form.Control type="text" value="Colours" disabled readOnly />
                  <input
                    type="hidden"
                    {...register("variant_name")}
                    value="Colours"
                  />

                  {errors.variant_name && (
                    <span className="text-danger">
                      {errors.variant_name.message}
                    </span>
                  )}
                </Form.Group>
              </Row>
            </div>
          </Col>

          {Number(variantType?.value) === variant_type.Single ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      {/* <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <Form.Label>
                              {watch("variant_name") || "Variant"}
                            </Form.Label>

                            <Form.Control
                              type="text"
                              placeholder={watch("variant_name") || "Variant"}
                              className={classNames("", {
                                "is-invalid":
                                  errors?.variants?.[index]?.metal_id,
                              })}
                              {...register(`variants.${index}.metal_id`, {
                                required: "variant is required",
                              })}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col> */}

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <Form.Label>
                              {watch("variant_name") || "Variant"}
                            </Form.Label>

                            <Controller
                              name={`variants.${index}.metal_id`}
                              control={control}
                              rules={{ required: "Colour is required" }}
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors?.variants?.[index]
                                        ?.metal_id
                                        ? "red"
                                        : baseStyles.borderColor,
                                    }),
                                  }}
                                  options={VariantNameOptions}
                                  onChange={(selectedValue) =>
                                    onChange(selectedValue)
                                  }
                                  onBlur={onBlur}
                                  value={value}
                                  ref={ref}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors.variants[index].metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      {/* <Col md={4}>
                      <div className="main-form-section mt-3">
                        <Form.Group>
                          <div className="">
                            <Form.Label>Size</Form.Label>
                          </div>

                          <Controller
                            className="select-contoller"
                            name={`variants.${index}.metal_id`}
                            control={control}
                            rules={{
                              required: "Select Size",
                            }}
                            render={({
                              field: { onChange, onBlur, value, ref },
                            }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.variants?.[index]
                                      ?.metal_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                                options={Metals}
                                onChange={(selectedValue) => {
                                  onChange(selectedValue);
                                }}
                                onBlur={onBlur}
                                value={value}
                                ref={ref}
                              />
                            )}
                          />

                          {errors?.variants?.[index]?.metal_id && (
                            <span className="text-danger">
                              {errors?.variants?.[index]?.metal_id.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </Col> */}

                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Variant MRP</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.mrp`} // Register color for the variant
                                placeholder="Variant MRP"
                                className={classNames("", {
                                  "is-invalid": errors?.variants?.[index]?.mrp,
                                })}
                                {...register(`variants.${index}.mrp`, {
                                  required: "Variant MRP is required",
                                })}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.mrp && (
                                <span className="text-danger">
                                  {errors.variants[index].mrp.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Variant Price</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`variants.${index}.price`} // Register color for the variant
                                placeholder="Variant Price"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.variants?.[index]?.price,
                                })}
                                {...register(`variants.${index}.price`, {
                                  required: "Variant name is required",
                                  validate: {
                                    lessThanPrice: (value) => {
                                      const mrp = getValues(
                                        `variants.${index}.mrp`,
                                      );
                                      if (
                                        parseFloat(value) >= parseFloat(mrp)
                                      ) {
                                        return "Price must be less than MRP";
                                      }
                                      return true;
                                    },
                                  },
                                })}
                                onKeyDown={(e) => {
                                  // Allow backspace, left and right arrow keys
                                  if (
                                    e.key === "Backspace" ||
                                    e.key === "ArrowLeft" ||
                                    e.key === "ArrowRight"
                                  ) {
                                    return; // Allow the action to continue
                                  }

                                  // Allow digits and decimal point
                                  if (!/[\d.]/.test(e.key)) {
                                    e.preventDefault(); // Block the invalid key
                                  }

                                  // Prevent multiple decimal points
                                  if (
                                    e.key === "." &&
                                    e.target.value.includes(".")
                                  ) {
                                    e.preventDefault(); // Block adding another decimal point
                                  }
                                }}
                              />
                              {errors?.variants?.[index]?.price && (
                                <span className="text-danger">
                                  {errors.variants[index].price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <div className="oder-detail-holder mb-3">
                        <div className="heading-holder">
                          <h6>3. Images Upload image (928 × 945 px).</h6>
                        </div>
                        <div className="package-details-section">
                          {/* Pickup Slot */}
                          <Row className="detail-row">
                            {/* <Col lg={4} md={4}>
                              <div className="d-flex align-items-center">
                                <Form.Control
                                  type="file"
                                  multiple
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleVariantImagesChange(e, index)
                                  }
                                />
                              </div>
                              {errors.images && (
                                <span className="text-danger">
                                  {errors.images.message}
                                </span>
                              )}
                            </Col>
                            <div className="img-row-holder">
                              <div className="d-flex flex-wrap gap-2 mt-2">
                                {variants?.[index]?.images?.map((file, i) => (
                                  <div
                                    key={i}
                                    className="position-relative"
                                  // onClick={() =>
                                  //   handleRemoveVariantImage(index, i)
                                  // }
                                  // style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="preview"
                                      style={{
                                        width: "80px",
                                        height: "80px",
                                        objectFit: "cover",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                      }}
                                    />


                                    {/* ❌ Cross Icon */}
                            {/* <span
                                      onClick={() =>
                                        handleRemoveVariantImage(index, i)
                                      }
                                      style={{
                                        position: "absolute",
                                        top: "-5px",
                                        right: "-5px",
                                        background: "red",
                                        color: "#fff",
                                        borderRadius: "50%",
                                        width: "18px",
                                        height: "18px",
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      ×
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div> */}

                            <Col lg={4} md={4}>
                              <div className="d-flex align-items-center">
                                <Form.Control
                                  type="file"
                                  name="images"
                                  multiple
                                  placeholder="Media"
                                  className={classNames("", {
                                    "is-invalid": errors?.images,
                                  })}
                                  accept="image/*,video/*"
                                  // onChange={handleMediaChange}
                                  onChange={(e) =>
                                    handleVariantImagesChange(e, index)
                                  }
                                  // REMOVE: {...register("images", { ... })}
                                />
                              </div>
                              {errors?.images && (
                                <span className="text-danger">
                                  {errors.images.message}
                                </span>
                              )}
                              {errors?.variants?.[index]?.images && (
                                <span className="text-danger">
                                  {errors.variants[index].images.message}
                                </span>
                              )}
                            </Col>
                            <div className="img-row-holder d-flex flex-wrap">
                              {/* {mediaPreviews &&
                                mediaPreviews.map((images, index) => {
                                  const isVideo = images.type === "video";
                                  return (
                                    <div className="mt-2 mx-3 position-relative" key={index}>
                                      {isVideo ? (
                                        <video
                                          src={images.url}
                                          controls
                                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                                          className="rounded"
                                        />
                                      ) : (
                                        <img
                                          src={images.url}
                                          alt={`Media Preview ${index}`}
                                          style={{ maxWidth: "100px", maxHeight: "100px", objectFit: "cover" }}
                                          className="rounded"
                                        />
                                      )}
                                      <button
                                        type="button"
                                        onClick={() => removeMedia(index)}
                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                                        style={{ width: "20px", height: "20px", fontSize: "12px", lineHeight: "1" }}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  );
                                })} */}
                              {(watch(`variants.${index}.images`) || []).map(
                                (file, i) => (
                                  <div
                                    key={i}
                                    className="position-relative mt-2 mx-3"
                                  >
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="preview"
                                      style={{
                                        width: 80,
                                        height: 80,
                                        objectFit: "cover",
                                      }}
                                      className="rounded"
                                    />
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleRemoveVariantImage(index, i)
                                      }
                                      className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                                      style={{
                                        width: 20,
                                        height: 20,
                                        fontSize: 12,
                                      }}
                                    >
                                      ×
                                    </button>
                                  </div>
                                ),
                              )}
                            </div>
                          </Row>
                        </div>
                      </div>
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : Number(variantType?.value) === variant_type.Double ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      {/* <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <Form.Label>
                              {watch("variant_name") || "Variant"}
                            </Form.Label>

                            <Form.Control
                              type="text"
                              placeholder={watch("variant_name") || "Variant"}
                              className={classNames("", {
                                "is-invalid":
                                  errors?.variants?.[index]?.metal_id,
                              })}
                              {...register(`variants.${index}.metal_id`, {
                                required: "variant is required",
                              })}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col> */}
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <Form.Label>
                              {watch("variant_name") || "Variant"}
                            </Form.Label>

                            <Controller
                              name={`variants.${index}.metal_id`}
                              control={control}
                              rules={{ required: "Colour is required" }}
                              render={({
                                field: { onChange, onBlur, value, ref },
                              }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                      borderColor: errors?.variants?.[index]
                                        ?.metal_id
                                        ? "red"
                                        : baseStyles.borderColor,
                                    }),
                                  }}
                                  options={VariantNameOptions}
                                  onChange={(selectedValue) =>
                                    onChange(selectedValue)
                                  }
                                  onBlur={onBlur}
                                  value={value}
                                  ref={ref}
                                />
                              )}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>

                      <div className="oder-detail-holder mb-3">
                        <div className="heading-holder">
                          <h6>3. Images Upload image (928 × 945 px).</h6>
                        </div>
                        <div className="package-details-section">
                          {/* Pickup Slot */}
                          <Row className="detail-row">
                            <Col lg={4} md={4}>
                              <div className="d-flex align-items-center">
                                <Form.Control
                                  type="file"
                                  name="images"
                                  multiple
                                  placeholder="Media"
                                  className={classNames("", {
                                    "is-invalid": errors?.images,
                                  })}
                                  accept="image/*,video/*"
                                  // onChange={handleMediaChange}
                                  onChange={(e) =>
                                    handleVariantImagesChange(e, index)
                                  }
                                  // REMOVE: {...register("images", { ... })}
                                />
                              </div>
                              {errors?.images && (
                                <span className="text-danger">
                                  {errors.images.message}
                                </span>
                              )}
                              {errors?.variants?.[index]?.images && (
                                <span className="text-danger">
                                  {errors.variants[index].images.message}
                                </span>
                              )}
                            </Col>
                            <div className="img-row-holder d-flex flex-wrap">
                              {/* {mediaPreviews &&
                                mediaPreviews.map((images, index) => {
                                  const isVideo = images.type === "video";
                                  return (
                                    <div className="mt-2 mx-3 position-relative" key={index}>
                                      {isVideo ? (
                                        <video
                                          src={images.url}
                                          controls
                                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                                          className="rounded"
                                        />
                                      ) : (
                                        <img
                                          src={images.url}
                                          alt={`Media Preview ${index}`}
                                          style={{ maxWidth: "100px", maxHeight: "100px", objectFit: "cover" }}
                                          className="rounded"
                                        />
                                      )}
                                      <button
                                        type="button"
                                        onClick={() => removeMedia(index)}
                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                                        style={{ width: "20px", height: "20px", fontSize: "12px", lineHeight: "1" }}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  );
                                })} */}
                              <div className="img-row-holder d-flex flex-wrap">
                                {(watch(`variants.${index}.images`) || []).map(
                                  (file, i) => (
                                    <div
                                      key={i}
                                      className="position-relative mt-2 mx-3"
                                    >
                                      <img
                                        src={URL.createObjectURL(file)}
                                        alt="preview"
                                        style={{
                                          width: 80,
                                          height: 80,
                                          objectFit: "cover",
                                        }}
                                        className="rounded"
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveVariantImage(index, i)
                                        }
                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle border-0"
                                        style={{
                                          width: 20,
                                          height: 20,
                                          fontSize: 12,
                                        }}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          </Row>
                        </div>
                      </div>

                      <DoubleVarient
                        useWatch={useWatch}
                        clearErrors={clearErrors}
                        setError={setError}
                        product_id={getValues(`variants.${index}.product_id`)}
                        singleIndex={index}
                        control={control}
                        variantType={variantType}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : Number(variantType?.value) === variant_type.Triple ? (
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>5.{variantType?.label} Variants</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Form.Group>
                            <Form.Label>
                              {watch("variant_name") || "Variant"}
                            </Form.Label>

                            <Form.Control
                              type="text"
                              placeholder={watch("variant_name") || "Variant"}
                              className={classNames("", {
                                "is-invalid":
                                  errors?.variants?.[index]?.metal_id,
                              })}
                              {...register(`variants.${index}.metal_id`, {
                                required: "variant is required",
                              })}
                            />

                            {errors?.variants?.[index]?.metal_id && (
                              <span className="text-danger">
                                {errors?.variants?.[index]?.metal_id.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </Col>
                      <div className="oder-detail-holder mb-3">
                        <div className="heading-holder">
                          <h6>3. Images Upload image (928 × 945 px).</h6>
                        </div>
                        <div className="package-details-section">
                          {/* Pickup Slot */}
                          <Row className="detail-row">
                            <Col lg={4} md={4}>
                              <div className="d-flex align-items-center">
                                <Form.Control
                                  type="file"
                                  multiple
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleVariantImagesChange(e, index)
                                  }
                                />
                              </div>
                              {errors.images && (
                                <span className="text-danger">
                                  {errors.images.message}
                                </span>
                              )}
                              {errors?.variants?.[index]?.images && (
                                <span className="text-danger">
                                  {errors.variants[index].images.message}
                                </span>
                              )}
                            </Col>
                            <div className="img-row-holder">
                              <div className="d-flex flex-wrap gap-2 mt-2">
                                {variants?.[index]?.images?.map((file, i) => (
                                  <div
                                    key={i}
                                    className="position-relative"
                                    onClick={() =>
                                      handleRemoveVariantImage(index, i)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="preview"
                                      style={{
                                        width: "80px",
                                        height: "80px",
                                        objectFit: "cover",
                                        border: "1px solid #ddd",
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          </Row>
                        </div>
                      </div>

                      <DoubleVarient
                        useWatch={useWatch}
                        clearErrors={clearErrors}
                        setError={setError}
                        variantType={variantType}
                        singleIndex={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                    </Row>
                    {fields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => remove(index)} // Remove the variant
                      >
                        Remove Variant
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Variant
                </button>
              </div>
            </div>
          ) : null}

          <div className="d-flex justify-content-center">
            <div className="text-center mt-4 mx-2">
              <button
                className="Back-button"
                type="submit"
                onClick={() => navigate("/products")}
              >
                {" "}
                Cancel
              </button>
            </div>

            <div className="text-center mt-4 mx-2">
              <button
                className="schedule-button"
                // type="submit"
                onClick={onSubmit}
              >
                Create Product
              </button>
            </div>
          </div>
        </Form>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Create;
